import { render, staticRenderFns } from "./temp_dia.vue?vue&type=template&id=5c0fdd7e&scoped=true"
import script from "./temp_dia.vue?vue&type=script&lang=js"
export * from "./temp_dia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fdd7e",
  null
  
)

export default component.exports